import { cookiebannerLabels as defaultLabels } from '@3pc/cookiebanner';

const isProduction = document.body.hasAttribute('data-production');
const siteId = document.body.getAttribute('data-trackingId');
const hideCookiebanner = document.body.hasAttribute('data-hide-cookiebanner');
const imprintLink =
  document.querySelector('[data-imprint-link]') &&
  JSON.parse(document.querySelector('[data-imprint-link]').dataset.imprintLink);
const privacyPolicyLink =
  document.querySelector('[data-privacy-policy-link]') &&
  JSON.parse(
    document.querySelector('[data-privacy-policy-link]').dataset
      .privacyPolicyLink
  );
const matomoSiteId = isProduction ? siteId : 7;
const matomoUrl = isProduction
  ? 'https://stats.berlinischegalerie.de/'
  : 'https://qa.linux15.3pc.de/matomo/';
const cookiebannerLabels = {
  ...defaultLabels,
  mainPanelTitle: {
    de: 'Ihre Cookie-Einstellungen',
    en: 'Your cookie settings',
  },
  mainPanelText: {
    de: `<p>Diese Website verwendet Cookies, um den reibungslosen Betrieb dieser Website zu gewährleisten und das Nutzungsverhalten der User*innen anonymisiert statistisch auszuwerten.</p> <p>Bei Cookies handelt es sich um kleine Textdateien, die auf Ihrem Endgerät bei Aufruf dieser Website gespeichert werden. Weitere Informationen finden Sie in unserer <a href=${privacyPolicyLink?.url}>Datenschutzerklärung</a> und im <a href=${imprintLink?.url}>Impressum</a>.</p>`,
    en: `<p>This website uses cookies to ensure the smooth operation of this website and to statistically analyse the user behaviour in an anonymous way.</p><p>Cookies are small text files that are stored on your terminal device when you access this website. You can find further information in our <a href=${privacyPolicyLink?.url}>privacy policy</a> and in the <a href=${imprintLink?.url}>imprint</a>.</p>`,
  },
  configPanelText: {
    de: null,
    en: null,
  },
  imprint: {
    de: 'Impressum',
    en: 'Imprint',
  },
  privacyPolicy: {
    de: 'Datenschutz',
    en: 'Privacy policy',
  },
};

const consentTypes = [
  {
    name: {
      de: 'Technische notwendige Cookies',
      en: 'Technically necessary cookies',
    },
    text: {
      de: `Die Nutzung dieser Cookies ist für den reibungslosen Betrieb der Website unbedingt erforderlich. Sie können nur in Ihren Browsereinstellungen deaktiviert werden, was sich jedoch auf die Funktionsweise der Website auswirken kann.`,
      en: 'The use of these cookies is absolutely necessary for the smooth operation of the website. They can only be deactivated in your browser settings, but this may affect the functioning of the website.',
    },
    type: 'required',
  },
  {
    name: {
      de: 'Statistik und Analyse Cookies',
      en: 'Statistics and analysis cookies',
    },
    text: {
      de: `Diese Cookies helfen uns, Informationen über die Nutzungsweise und das Besucher*innenverhalten auf unserer Website zu erhalten. Dadurch können wir unser Angebot kontinuierlich verbessern und an Ihre Bedürfnisse anpassen. Wir fragen die Einwilligung zur Verwendung dieser Cookies im Sinne DSGVO und TTDSG ab.
      <table class="rtable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Anbieter</th>
            <th>Speicherdauer</th>
            <th>Zweck</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>MATOMO_SESSID</td>
            <td>stats.berlinischegalerie.de</td>
            <td>Sitzung</td>
            <td>Sitzungsverwaltung</td>
          </tr>
          <tr>
            <td>_pk_id.1.8292</td>
            <td>berlinischegalerie.de Matomo (Piwik)</td>
            <td>1 Jahr</td>
            <td>Erfasst Statistiken über Besuche auf der Website, wie z.B. die Anzahl der Besuche, durchschnittliche Verweildauer auf der Website und welche Seiten gelesen wurden.</td>
          </tr>
          <tr>
            <td>_pk_ses.1.8292</td>
            <td>berlinischegalerie.de Matomo (Piwik)</td>
            <td>1 Tag</td>
            <td>Wird von Matomo genutzt, um Seitenabrufe der Besucher*innen während der Sitzung nachzuverfolgen.</td>
          </tr>
        </tbody>
      </table>
      `,
      en: `These cookies help us to obtain information about the usage patterns and visitor behaviour on our website. This allows us to continuously improve our services and adapt them to your needs. We request your consent to the use of these cookies in accordance with the German Data Protection Act (DSGVO) and the German Teleservices Data Protection Act (TTDSG).
        <table class="rtable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Provider</th>
            <th>Storage period</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>MATOMO_SESSID</td>
            <td>stats.berlinischegalerie.de</td>
            <td>Session</td>
            <td>Session management</td>
          </tr>
          <tr>
            <td>_pk_id.1.8292</td>
            <td>berlinischegalerie.de Matomo (Piwik)</td>
            <td>1 year</td>
            <td>Records statistics about visits to the website, such as the number of visits, average time spent on the website and which pages were read.</td>
          </tr>
          <tr>
            <td>_pk_ses.1.8292</td>
            <td>berlinischegalerie.de Matomo (Piwik)</td>
            <td>1 day</td>
            <td>Used by Matomo to track visitors' page views during the session.</td>
          </tr>
        </tbody>
      </table>
      `,
    },
    type: 'matomo',
    trackingScripts: [
      {
        insertSelector: 'body',
        script: `var _paq = window._paq = window._paq || [];
          _paq.push(['trackPageView']);
          _paq.push(['enableLinkTracking']);
          (function() {
          var u="${matomoUrl}";
          _paq.push(['setTrackerUrl', u+'matomo.php']);
          _paq.push(['setSiteId', '${matomoSiteId}'])
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
          })();`,
      },
    ],
  },
  {
    name: {
      de: 'Marketing',
      en: 'Marketing',
    },
    text: {
      de: `Marketing Cookies werden von externen Werbediensteistern (Google und Meta) gesetzt. Sie dienen der Profilerstellung und Datenverfolgung über mehrere Websites hinweg. Wenn Sie diese Cookies akzeptieren, können wir unsere Werbung auf anderen Websites basierend auf Ihrem Benutzerprofil und Ihren Präferenzen anzeigen. Diese Cookies speichern auch Daten darüber, wie viele Besucher*innen unsere Werbung gesehen oder angeklickt haben, um Werbekampagnen zu optimieren.`,
      en: `Marketing cookies are set by external advertising services (Google and Meta). They are used for profiling and data tracking across multiple websites. If you accept these cookies, we can display our ads on other websites based on your user profile and preferences. These cookies also store data about how many visitors have seen or clicked on our ads in order to optimise advertising campaigns.`,
    },
    type: 'marketing',
    trackingScripts: [
      {
        insertSelector: 'body',
        scriptLink: `https://www.googletagmanager.com/gtag/js?id=AW-10857548525`,
      },
      {
        insertSelector: 'body',
        script: `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-10857548525');`,
      },
      {
        insertSelector: 'head',
        script: `!function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '205316412169888');
          fbq('track', 'PageView');`,
      },
      {
        insertSelector: 'head',
        noscript: `<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=205316412169888&ev=PageView&noscript=1"
          />`,
      },
    ],
  },
  {
    name: {
      de: 'Tickets',
      en: 'Tickets',
    },
    text: {
      de: `Wir verwenden den Service eines Drittanbieters, um die Funktionalität zur Ticketbuchung einzubetten.`,
      en: `We use a third-party service to embed ticket booking functionality.`,
    },
    type: 'tickets',
  },
  {
    name: {
      de: 'Eingebettete Inhalte',
      en: 'Embedded Content',
    },
    text: {
      de: `Wir verwenden Services von Drittanbietern (Spotify, YouTube und Vimeo), um externe Inhalte (Video- und Audioplayer) einzubetten. Die Einbettung erfolgt für eine möglichst benutzer*innenfreundliche Darstellung und Bedienung der Inhalte. Wenn Sie das Einbetten externer Inhalten erlauben, stimmen Sie damit zu, dass dabei personenbezogene Daten an die Drittanbieter übermittelt werden können. Sie können Ihre Zustimmung jederzeit rückgängig machen.
      <table class="rtable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Anbieter</th>
            <th>Speicherdauer</th>
            <th>Zweck</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>vuid</td>
            <td>399 Tage</td>
            <td>vimeo.com</td>
            <td>Sammelt Daten über Besuche auf der Website, wie zum Beispiel welche Seiten gelesen wurden.</td>
          </tr>
          <tr>
            <td>__cf_bm</td>
            <td>vimeo.com</td>
            <td>1 Tag</td>
            <td>Wird verwendet, um zwischen Menschen und Bots zu unterscheiden. Dies ist vorteilhaft für die Website, um gültige Berichte über die Nutzung der Website zu erstellen.</td>
          </tr>
          <tr>
            <td>CONSENT</td>
            <td>youtube-nocookie.com </td>
            <td>2 Jahre</td>
            <td>Wird verwendet, um festzustellen , ob die Besucher*in die Kategorie „Statistik und Analyse“ im Cookie-Banner akzeptiert hat</td>
          </tr>
        </tbody>
      </table>
      `,
      en: `We use third-party services (Spotify, YouTube and Vimeo) to embed external content (video and audio players). The embedding is done for the most user-friendly presentation and operation of the content. If you allow the embedding of external content, you agree that personal data may be transmitted to the third-party providers. You can withdraw your consent at any time.
      <table class="rtable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Provider</th>
            <th>Storage Duration</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>vuid</td>
            <td>399 days</td>
            <td>vimeo.com</td>
            <td></td>
          </tr>
          <tr>
            <td>__cf_bm</td>
            <td>vimeo.com</td>
            <td>1 Tag</td>
            <td>Used to distinguish between humans and bots. This is beneficial for the website to generate valid reports on website usage.</td>
          </tr>
          <tr>
            <td>CONSENT</td>
            <td>youtube-nocookie.com </td>
            <td>2 Jahre</td>
            <td>Used to determine whether the visitor has accepted the "Statistics and Analytics" category in the cookie banner.</td>
          </tr>
        </tbody>
      </table>
      `,
    },
    type: 'embed',
  },
];

export {
  hideCookiebanner,
  imprintLink,
  privacyPolicyLink,
  cookiebannerLabels,
  consentTypes,
};
